<app-header></app-header>
<div class="text-center">
    {{ 'ComingSoon' | translate }}
</div>
<app-footer></app-footer>
